// extracted by mini-css-extract-plugin
export default {"wrapper":"devotions_wrapper__qO48t","image":"devotions_image__v8Rrb","inside":"devotions_inside__1iBzU"};